import useCognito from "./useCognito";

const Cognito = () => {
  useCognito();

  return null;
};

export default Cognito;
